
<div class="cmp-sidebar-layout">
  <div class="content">
    <div class="cmp-sidebar-layout-inner transition-all">
      <slot></slot>
    </div>
  </div>

  <div class="side" data-v-sticky-container>
    <div ref="side" v-sticky="stickyOptions" tabindex="0">
      <slot name="side" data-v-sticky-inner></slot>
    </div>
  </div>
</div>
